export const ACH_FIELDS = {
  'ach-account-holder': { label: 'Account holder name', wrapper: 'payment-input-wrapper' },
  'ach-account-type': { label: 'Account type', wrapper: 'payment-input-type-wrapper' },
  'ach-routing-number': { label: 'Routing number', wrapper: 'payment-input-wrapper' },
  'ach-account-number': { label: 'Account number', wrapper: 'payment-input-wrapper' }
};

const STACKED_ROW = 'flex w-full flex-col gap-1';
const SIDE_BY_SIDE_ROW = 'flex w-full items-start gap-3 sm:flex-col';

export const DEFAULT_ACH_FIELD_ROWS = Object.keys(ACH_FIELDS).map((field) => ({
  fields: [field],
  className: STACKED_ROW
}));

export const PAIRED_ACH_FIELD_ROWS = [
  { fields: ['ach-account-holder', 'ach-account-type'], className: SIDE_BY_SIDE_ROW },
  { fields: ['ach-routing-number', 'ach-account-number'], className: SIDE_BY_SIDE_ROW }
];
